// extracted by mini-css-extract-plugin
export default {"component":"ParticipantsToShareComponent_component__LIoIy","rightBody":"ParticipantsToShareComponent_rightBody__oOTA6","icon":"ParticipantsToShareComponent_icon__6eKPd"};